import { DocumentNode, gql } from '@apollo/client';

import { SaveDocumentRequest } from '../../../contracts/SaveDocumentRequest';

// correlationId und trackingId werden als GraphQL-Variablen übergeben (Injection-Schutz).
// data ist eine numerische Byte-Liste (Uint8Array) und damit nicht injizierbar; sie
// bleibt aus Typgründen inline.
export function saveDocumentMutation(saveDocumentRequest: SaveDocumentRequest): DocumentNode {
  return gql`
    mutation SaveDocument($correlationId: String!, $trackingId: String!) {
      saveDocument(input: {
        correlationId: $correlationId
        data: [${saveDocumentRequest.data}]
        trackingId: $trackingId
      })
      {
        string
      }
    }
  `;
}
